import { ReferenceData } from './reference-data.model';

export class ActionReason extends ReferenceData {

  actionId: { correlation: string };

  // tslint:disable-next-line:no-any
  constructor(data: any) {
    super(data);
    this.actionId = data.actionId;
  }
}
